import React from 'react';
import { createBrowserRouter } from 'react-router-dom';
import App from '../App';

import Home from '../Screens/Homescreen/Home';
import About from '../Screens/About/About';
import Services from '../Screens/Services/Services';
import Projects from '../Screens/Projects/Projects';
import NoticePage from '../Screens/Notice/NoticePage';
import TendersPage from '../Screens/TendersPage/TendersPage';
import DownloadPage from '../Screens/DownloadPage/DownloadPage';
import GalleryPage from '../Screens/GalleryPage/GalleryPage';
import ContactUs from '../Screens/ContactUs/ContactUs';
import SearchPage from '../Screens/SearchPage/SearchPage';
import TestPage from '../Screens/TestPage/TestPage';
import Faq from '../Screens/Faq/Faq';
import ImportantLinks from '../Screens/ImportantLinks/ImportantLinks';
import Circulars from '../Screens/Circulars/Circulars';
import GrievancePage from '../Screens/Grievance/GrievancePage';
import ManagementDeskPage from '../Screens/ManagementDesk/ManagementDeskPage';
import Department from '../Screens/Department/Department';
import PublicationReports from '../Screens/Publication & Reports/PublicationReports';
import SocietyCorner from '../Screens/Society\'s Corner/SocietyCorner';
import Events from '../Screens/Events/Events';
import MarketingProcurement from '../Screens/MarketingProcurement/MarketingProcurement';
import Fertilizer from '../Screens/Fertilizer/Fertilizer';
import Inputs from '../Screens/Inputs/Inputs';
import Engineering from '../Screens/Engineering/Engineering';
import WhoWeAre from '../Screens/WhoWeAre/WhoWeAre';
import OurMission from '../Screens/OurMission/OurMission';
import OrganizationalStructure from '../Screens/OrganizationalStructure/OrganizationalStructure';
import Members from '../Screens/Members/Members';
import AvailableProductPage from '../Screens/AvailableProductPage/AvailableProductPage';
import WareHouse from '../Screens/WareHouse/WareHouse';
import FormsPage from '../Screens/FormsPage/FormsPage';
import FinancialStatementsPage from '../Screens/FinancialStatementsPage/FinancialStatementsPage';
import Achievement from '../Screens/Achievement/Achievement';

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { path: "", element: <Home /> },
      { path: "about", element: <About /> },
      { path: "services", element: <Services /> },
      { path: "projects", element: <Projects /> },
      { path: "notice", element: <NoticePage /> },
      { path: "tenders", element: <TendersPage /> },
      { path: "downloads-forms", element: <DownloadPage /> },
      { path: "gallery", element: <GalleryPage /> },
      { path: "contact-us", element: <ContactUs /> },
      { path: "search", element: <SearchPage /> },
      { path: "test", element: <TestPage /> },
      { path: "faq", element: <Faq /> },
      { path: "importantLinks", element: <ImportantLinks /> },
      { path: "circulars", element: <Circulars /> },
      { path: "grievance", element: <GrievancePage /> },
      { path: "management-desk", element: <ManagementDeskPage /> },
      { path: "department", element: <Department /> },
      { path: "publication-reports", element: <PublicationReports /> },
      { path: "society-corner", element: <SocietyCorner /> },
      { path: "events", element: <Events /> },
      { path: "marketing-procurement", element: <MarketingProcurement /> },
      { path: "fertilizer", element: <Fertilizer /> },
      { path: "inputs", element: <Inputs /> },
      { path: "engineering", element: <Engineering /> },
      { path: "who-we-are", element: <WhoWeAre /> },
      { path: "achievement", element: <Achievement /> },
      { path: "our-mission", element: <OurMission /> },
      { path: "organizational-structure", element: <OrganizationalStructure /> },
      { path: "members", element: <Members /> },
      { path: "available-product", element: <AvailableProductPage /> },
      { path: "ware-house", element: <WareHouse /> },
      { path: "forms", element: <FormsPage /> },
      { path: "financial-statements", element: <FinancialStatementsPage /> }
    ]
  }
]);

export default router;
